<template>

	<div class="masthead__lower">
		<div class="masthead__sub-headline">
			<h3><slot name="subHeadlineUpper" /></h3>
			<h3><slot name="subHeadlineLower" /></h3>
			<p><slot name="subHeadlineContent" /></p>
		</div>
		<div class="masthead__cta">
			<slot name="cta" />
		</div>
	</div>

</template>

<script>

	export default {
		name: "MastheadVideo"
	}

</script>

<style lang="scss" scoped>

	@import "media.scss";
	@import "list-style-reset.scss";
	@import "responsive-font.scss";

	.masthead {
		&__lower {
			display:flex; justify-content:space-between; align-items:flex-start; margin-top:30vh;
		}
		&__sub-headline {
			color:#ffffff; max-width:52.2rem; margin-right:3vw;
			h3 {
				@include responsive-font(40);
				line-height:1.25; font-weight:400; color:inherit;
				& + h3 {
					color:#FDB913; margin-bottom:2.8vh;
				}
			}
			p {
				margin:0; font-weight:inherit;
			}
		}
		&__cta {
			ul {
				@include list-style-reset;
			}
			li {
				& + li {
					margin-top:3vh;
				}
				a {
					display:flex; text-decoration:none;
				}
				div {
					max-width:30rem; margin-left:3.2rem;
				}
				figure {
					position:relative;
					img {
						display:block;
					}
					&:after {
						width:70px; height:70px; background:url("~/src/assets/img/play-small.png") center no-repeat; position:absolute; left:0; bottom:0; content:'';
					}
				}
				h4, h5 {
					font-family:"proxima-nova";
				}
				h4 {
					@include responsive-font(12);
					line-height:1.16; font-weight:400; color:#FDB913; text-transform:uppercase; letter-spacing:2px;
				}
				h5 {
					@include responsive-font(18);
					color:#ffffff; font-weight:600; line-height:1.66;
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/Products/MastheadVideo.vue